<template>
	<div style="display:none;"></div>
</template>

<script>
export default {
    props: ['map', 'layer', 'origin'],

    created() {
        let lat = (this.$store.state.client.make_destination_center && this.$store.state.destinationPoint) ?
            this.$store.state.destinationPoint.latitude :
            this.$store.state.originPoint.latitude

        let lng = (this.$store.state.client.make_destination_center && this.$store.state.destinationPoint) ?
            this.$store.state.destinationPoint.longitude :
            this.$store.state.originPoint.longitude

        this.mapsLayers = this.layer.circles.map(circle => {
            return new this.mapsApi.maps.Circle({
                strokeColor: circle.attributes?.circle_color || circle.circle_color,
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: circle.attributes?.circle_color || circle.circle_color, 
                fillOpacity: 0.15,
                map: this.map,
                center: {lat, lng},
                radius: parseInt(circle.attributes?.circle_radius || circle.circle_radius),
                clickable: false
            })
        })

        if (this.layer.title.toLowerCase().includes('promenad') || this.layer.title.toLowerCase().includes('walk')) {
            this.$store.state.walkingCircles = this.mapsLayers
        }

        this.kmlLayers = this.layer.kml_files.map(kml => {
            return new this.mapsApi.maps.KmlLayer(this.$imgUrl(kml.attributes?.file || kml.file), {
                suppressInfoWindows: true,
                preserveViewport: true,
                map: this.map
            })
        })
        
        // Google internal layers
        if ( ! this.layer.activate_layers) {
            return
        }

        this.googleLayers = []

        if (this.layer.activate_layers.bicycling) {
            this.googleLayers.push({
                type: 'bicycling',
                layer: new this.mapsApi.maps.BicyclingLayer()
            })
        }

        if (this.layer.activate_layers.traffic) {
            this.googleLayers.push({
                type: 'traffic',
                layer: new this.mapsApi.maps.TrafficLayer()
            })
        }

        if (this.layer.activate_layers.transit) {
            this.googleLayers.push({
                type: 'transit',
                layer: new this.mapsApi.maps.TransitLayer()
            })
        }

        for (let googleLayer of this.googleLayers) {
            googleLayer.layer.setMap(this.map)
        }
    },

    beforeDestroy() {
        if (this.mapsLayers) {
            for (let mapsLayer of this.mapsLayers) {
                mapsLayer.setMap(null)
            }
        }
        
        if (this.kmlLayers) {
            for (let kmlLayer of this.kmlLayers) {
                kmlLayer.setMap(null)
            }
        }

        if (this.googleLayers) {
            for (let googleLayer of this.googleLayers) {
                if ( ! this.activeGoogleLayers.includes(googleLayer.type)) {
                    googleLayer.layer.setMap(null)
                }
            }
        }
    },

    computed: {
        mapsApi() {
            return this.$store.state.mapsApi
        },

        endUser() {
            return this.$store.state.endUser
        },

        // To avoid cancelling google layers present on other active layers, filter out yourself
        activeGoogleLayers() {
            let activatedLayers = this.$store.state.layers
                .filter(l => l.active && l.id !== this.layer.id)
                .map(l => l.activate_layers)

            let activated = []

            for (let layer of activatedLayers) {
                for (let property in layer) {
                    if (layer[property] === true) {
                        activated.push(property)
                    }
                }
            }

            return activated
        }
    }
}
</script>